<template>
  <div class="tab-container">
    <app-spinner v-if="!page_loaded" />
    <app-cells v-if="page_loaded && (is_general_manager || is_sales_manager || is_sales_supervisor || is_support)">
      <app-button @click.native="onShowCreateModal">Create client</app-button>
      <app-button @click.native="onCopyFamilyLinks">Copy all links</app-button>
    </app-cells>
    <v-client-table
      v-if="page_loaded"
      :data="table.items"
      :columns="table.columns"
      :options="table.options"
      class="table-default"
    >
      <template #h__select>
        <label
          v-if="table.items.length"
          class="checkbox checkbox--table"
        >
          <input
            v-model="checked_all"
            type="checkbox"
            name="checked_all"
            ref="mainCh"
          />
          <span class="checkbox__checkmark"></span>
        </label>
      </template>
      <template #h__full_name>
        <div class="table-default__left">Full name</div>
      </template>
      <template #h__insurance_upd>
        <span class="insurance-update-heading">Insurance update</span>
      </template>
      <template #insurance_upd="{ row }">
        <div class="table-default__controls">
          <span
            v-for="channel in insuranceUpdateChannels"
            :key="channel.value"
            v-tooltip="{ content: insuranceUpdateTooltip(row.id, channel.value), placement: 'top-start', offset: 10 }"
            :aria-label="insuranceUpdateTooltip(row.id, channel.value)"
            tabindex="0"
            class="table-default__activity insurance-update-status"
            :class="[`table-default__activity--${channel.icon}`, `insurance-update-status--${insuranceUpdateTone(row.id, channel.value)}`]"
          ></span>
        </div>
      </template>
      <template #select="{ row }">
        <label class="checkbox  checkbox--table">
          <input
            v-model="checked"
            type="checkbox"
            :value="row.id"
          />
          <span class="checkbox__checkmark"></span>
        </label>
      </template>
      <template #full_name="{ row }">
        <div class="table-default__left table-default__controls">
          <button v-if="is_general_manager || is_sales_manager || is_sales_supervisor" @click="onCopyFamilyLink(row.hash)" type="button">
            <img src="@/assets/img/a-table-icon.svg" alt="">
          </button>
          <!--<button type="button"><img src="@/assets/img/to-table-icon.svg" alt=""></button>-->
          <router-link :to="{name: 'clients-detail', params: {id: row.id }}" class="table-default__link-border">
            {{ row.full_name }}
          </router-link>
          <img v-if="row.category && row.category.code === 'tour_leader'" src="@/assets/img/tour-leader-icon.svg" alt="Leader">
          <img v-if="row.group.is_primary_contact" src="@/assets/img/bookmark-icon.svg" alt="Primary">
        </div>
      </template>
      <template #messengers="{ row }">
        <div class="table-default__controls">
          <button
            v-tooltip="{content: row.communication.email, placement: 'top-start', offset: 10}"
            @click="onCopyContactLink(row.communication.email)"
            class="table-default__activity table-default__activity--mail"
            :class="{'table-default__activity--active': row.communication.email}"
          >
          </button>
          <button
            v-tooltip="{content: row.communication.phone, placement: 'top-start', offset: 10}"
            @click="onCopyContactLink(row.communication.phone)"
            class="table-default__activity table-default__activity--phone"
            :class="{'table-default__activity--active': row.communication.phone}"
          >
          </button>
          <a
            :href="`https://t.me/${row.communication.phone}`"
            target="_blank"
            class="table-default__activity table-default__activity--tg"
            :class="{'table-default__activity--active': row.communication.phone_telegram}"
          >
          </a>
          <a
            :href="`https://wa.me/${row.communication.phone}`"
            target="_blank"
            class="table-default__activity table-default__activity--wa"
            :class="{'table-default__activity--active': row.communication.phone_whatsapp}"
          >
          </a>
        </div>
      </template>
      <template #transport="{ row }">
        <div class="table-default__controls">
          <button
            @click="onCopyTransportData(row.transport.arrival, 'arrival')"
            v-tooltip="{ content: tooltipTransportContent(row.transport.arrival, 'arrival'), placement: 'top-start', offset: 10, html: true }"
            class="table-default__transport table-default__transport--arrival"
            :class="{
              'table-default__transport--present': row.transport.arrival.arrival_method,
              'table-default__transport--confirmed': row.transport.arrival.arrival_confirmed,
              'table-default__transport--car': row.transport.arrival.arrival_method?.code === 'car',
              'table-default__transport--bus': row.transport.arrival.arrival_method?.code === 'bus',
              'table-default__transport--self': row.transport.arrival.arrival_method?.code === 'self'
            }"
          ></button>
          <button
            @click="onCopyTransportData(row.transport.departure, 'departure')"
            v-tooltip="{ content: tooltipTransportContent(row.transport.departure, 'departure'), placement: 'top-start', offset: 10, html: true }"
            class="table-default__transport table-default__transport--departure"
            :class="{
              'table-default__transport--present': row.transport.departure.departure_method,
              'table-default__transport--confirmed': row.transport.departure.departure_confirmed,
              'table-default__transport--car': row.transport.departure.departure_method?.code === 'car',
              'table-default__transport--bus': row.transport.departure.departure_method?.code === 'bus',
              'table-default__transport--self': row.transport.departure.departure_method?.code === 'self'
            }"
          ></button>
        </div>
      </template>
      <template #personal_data_percentage="{ row }">
        <div class="table-default__controls">
          <span class="table-default__percent" :class="{'table-default__percent--disabled': row.personal_detail.personal_data_percentage < 95}">
            <img src="@/assets/img/percent-icon.svg" alt="Percent">
            <span>{{ row.personal_detail.personal_data_percentage }}</span>
          </span>
          <template v-if="is_general_manager || is_sales_manager || is_sales_supervisor || is_operations_supervisor">
            <button
              @click="onCopyContactLink(`${row.personal_detail.citizenship.code}, ${row.personal_detail.passport}, ${dateFormat(row.personal_detail.dob)}`)"
              v-tooltip="{content: tooltipPassportContent(row.personal_detail), placement: 'top-start', offset: 10, html: true}"
              class="table-default__activity table-default__activity--adds table-default__activity--passport"
              :class="{
                'table-default__activity--active': row.personal_detail.passport && row.personal_detail.passport_expiration_date && row.personal_detail.citizenship,
                'table-default__activity--pin-green': row.personal_detail.passport_required && row.personal_detail.passport_copy,
                'table-default__activity--pin-red': row.personal_detail.passport_required && !row.personal_detail.passport_copy
              }"
            ></button>
            <span
              class="table-default__activity table-default__activity--adds table-default__activity--active table-default__activity--residence"
              :class="{
                'table-default__activity--resident': row.personal_detail.residence?.code === 'resident',
                'table-default__activity--foreigner': row.personal_detail.residence?.code === 'foreigner',
                'table-default__activity--ea': row.personal_detail.residence?.code === 'east_african',
                'table-default__activity--pin-green': row.personal_detail.residence_permit_required && row.personal_detail.residence_permit_copy,
                'table-default__activity--pin-red': row.personal_detail.residence_permit_required && !row.personal_detail.residence_permit_copy
              }"
            ></span>
          </template>
        </div>
      </template>
      <template #climbing="{ row }">
        <div class="table-default__controls">
          <router-link
            v-if="row.climbing.length === 1"
            v-tooltip="{ content: tooltipClimbingContent(row.climbing[0].group), placement: 'top-start', offset: 10, html: true }"
            :to="{name: 'climbing-groups-detail', params: {id: row.climbing[0].group.id}}"
            class="table-default__activity table-default__activity--climbing table-default__activity--active"
          ></router-link>
          <button
            v-else
            @click="onShowActivitiesModal(row, 'climbing')"
            type="button"
            class="table-default__activity table-default__activity--climbing"
            :class="{'table-default__activity--active': row.climbing.length}"
          ></button>
          <button
            @click="onCopyInsuranceData(row.climbing_insurance, 'climbing')"
            v-tooltip="{content: tooltipInsuranceContent(row.climbing_insurance, 'climbing'), placement: 'top-start', offset: 10, html: true}"
            class="table-default__insurance"
            :class="{ 'table-default__insurance--climbing': row.climbing_insurance.climbing_insurance_company }"
          ></button>
          <template v-if="row.climbing.length === 1">
            <a
              v-if="is_general_manager || is_sales_manager || is_sales_supervisor || is_operations_supervisor"
              :href="`${family_url}${row.hash}/rentals/${row.climbing[0].group.id}`"
              target="_blank"
              v-tooltip="{content: tooltipChecklistContent(row.climbing[0].checklist), placement: 'top-start', offset: 10, html: true}"
              class="table-default__activity table-default__activity--checklist table-default__activity--active table-default__activity--adds"
              :class="{
                'table-default__activity--checklist-total': row.climbing[0].checklist.completed && row.climbing[0].checklist.total_price === 0,
                'table-default__activity--checklist-time': !row.climbing[0].checklist.completed,
                'table-default__activity--checklist-complete': row.climbing[0].checklist.completed && row.climbing[0].checklist.total_price > 0
              }"
            ></a>
            <span
              v-if="!is_general_manager && !is_sales_manager && !is_sales_supervisor && !is_operations_supervisor"
              v-tooltip="{content: tooltipChecklistContent(row.climbing[0].checklist), placement: 'top-start', offset: 10, html: true}"
              class="table-default__activity table-default__activity--checklist table-default__activity--active table-default__activity--adds"
              :class="{
                'table-default__activity--checklist-total': row.climbing[0].checklist.completed && row.climbing[0].checklist.total_price === 0,
                'table-default__activity--checklist-time': !row.climbing[0].checklist.completed,
                'table-default__activity--checklist-complete': row.climbing[0].checklist.completed && row.climbing[0].checklist.total_price > 0
              }"
            ></span>
          </template>
          <button
            v-else
            @click="onShowActivitiesModal(row, 'climbing')"
            type="button"
            class="table-default__activity table-default__activity--checklist"
            :class="{
                'table-default__activity--active': row.climbing.length,
              }"
          ></button>
          <a
            :href="`${family_url}${row.hash}/medical`"
            target="_blank"
            class="table-default__activity table-default__activity--medical-climbing table-default__activity--adds"
            :class="{
              'table-default__activity--active': row.climbing.length,
              'table-default__activity--medical-climbing-clock': !row.medical_clearance,
              'table-default__activity--medical-climbing-complete': row.medical_clearance,
              }"
          ></a>
        </div>
      </template>
      <template #safari="{ row }">
        <div class="table-default__controls">
          <router-link
            v-if="row.safari.length === 1"
            v-tooltip="{ content: tooltipSafariContent(row.safari[0].group), placement: 'top-start', offset: 10, html: true }"
            :to="{name: 'safari-groups-detail', params: {id: row.safari[0].group.id}}"
            class="table-default__activity table-default__activity--safari table-default__activity--active"
          ></router-link>
          <button
            v-else
            @click="onShowActivitiesModal(row, 'safari')"
            type="button"
            class="table-default__activity table-default__activity--safari"
            :class="{'table-default__activity--active': row.safari.length}"
          ></button>
          <button
            @click="onCopyInsuranceData(row.safari_insurance, 'safari')"
            v-tooltip="{content: tooltipInsuranceContent(row.safari_insurance, 'safari'), placement: 'top-start', offset: 10, html: true}"
            class="table-default__insurance"
            :class="{ 'table-default__insurance--safari': row.safari_insurance.safari_insurance_company }"
          ></button>
          <a
            v-if="row.safari.length === 1"
            :href="`${family_url}${row.hash}/snacks/${row.safari[0].hash}`"
            target="_blank"
            v-tooltip="{content: tooltipSnackBarContent(row.safari[0]), placement: 'top-start', offset: 10, html: true}"
            class="table-default__activity table-default__activity--snacks table-default__activity--adds table-default__activity--active"
            :class="{
              'table-default__activity--snacks-time': !row.safari[0].snack_bar.completed,
              'table-default__activity--snacks-no-need': row.safari[0].snack_bar.no_need,
              'table-default__activity--snacks-usd': row.safari[0].snack_bar.completed && row.safari[0].snack_bar.outstanding_amount > 0,
              'table-default__activity--snacks-complete': row.safari[0].snack_bar.completed && row.safari[0].snack_bar.outstanding_amount === 0
            }"
          ></a>
          <button
            v-else
            @click="onShowActivitiesModal(row, 'safari')"
            type="button"
            class="table-default__activity table-default__activity--snacks"
            :class="{
                'table-default__activity--active': row.safari.length,
              }"
          ></button>
        </div>
      </template>
      <template #day_trips="{ row }">
        <div class="table-default__controls">
          <router-link
            v-if="row.day_trips.length === 1"
            v-tooltip="{ content: tooltipDayTripsContent(row.day_trips[0]), placement: 'top-start', offset: 10, html: true }"
            :to="{name: 'day-trips-groups-detail', params: {id: row.day_trips[0].id}}"
            class="table-default__activity table-default__activity--day_trips table-default__activity--active table-default__activity--adds"
            :class="{ 'table-default__activity--medical-climbing-clock': row.day_trips[0]?.pick_up_time_to_be_confirmed }"
          ></router-link>
          <button
            v-else
            @click="onShowActivitiesModal(row, 'day_trips')"
            class="table-default__activity table-default__activity--day_trips table-default__activity--adds"
            :class="{
              'table-default__activity--active': row.day_trips.length,
              'table-default__activity--medical-climbing-clock': row.day_trips[0]?.pick_up_time_to_be_confirmed,
            }"
          ></button>
          <router-link
            v-if="row.island_vacation_groups.length === 1"
            v-tooltip="{ content: tooltipIslandContent(row.island_vacation_groups[0]), placement: 'top-start', offset: 10, html: true }"
            :to="{name: 'island-vacation-groups-detail-clients', params: {id: row.island_vacation_groups[0].id}}"
            class="table-default__activity table-default__activity--island table-default__activity--active table-default__activity--adds"
          ></router-link>
          <button
            v-else
            @click="onShowActivitiesModal(row, 'island_vacation_groups')"
            class="table-default__activity table-default__activity--island table-default__activity--adds"
            :class="{
              'table-default__activity--active': row.island_vacation_groups.length,
            }"
          ></button>
          <router-link
            v-if="row.free_days.length === 1"
            v-tooltip="{ content: tooltipFreeDaysContent(row.free_days[0]), placement: 'top-start', offset: 10, html: true }"
            :to="{name: 'free-days-detail', params: {id: row.free_days[0].id}}"
            class="table-default__activity table-default__activity--free_days table-default__activity--active table-default__activity--adds"
          ></router-link>
          <button
            v-else
            @click="onShowActivitiesModal(row, 'free_days')"
            class="table-default__activity table-default__activity--free_days table-default__activity--adds"
            :class="{
              'table-default__activity--active': row.free_days.length,
            }"
          ></button>
        </div>
      </template>
      <template #transfers="{ row }">
        <div class="table-default__controls">
          <button
            @click="onShowActivitiesModal(row, 'transfers', 'arrival')"
            type="button"
            class="table-default__activity table-default__activity--adds table-default__activity--transfers-arrival"
            :class="{
              'table-default__activity--active': row.transfers.arrival.length,
              'table-default__activity--transfers-arrival-arranged': row.transfers.arrival[0]?.status?.code === 'arranged',
              'table-default__activity--transfers-arrival-cancelled': row.transfers.arrival[0]?.status?.code === 'cancelled',
              'table-default__activity--transfers-arrival-requested': row.transfers.arrival[0]?.status?.code === 'requested' || row.transfers.arrival?.status?.code === 'need_amended'
            }"
          >
          </button>
          <button
            @click="onShowActivitiesModal(row, 'transfers', 'departure')"
            type="button"
            class="table-default__activity table-default__activity--adds table-default__activity--transfers-departure"
            :class="{
              'table-default__activity--active': row.transfers.departure.length,
              'table-default__activity--transfers-departure-arranged': row.transfers.departure[0]?.status?.code === 'arranged',
              'table-default__activity--transfers-departure-cancelled': row.transfers.departure[0]?.status?.code === 'cancelled',
              'table-default__activity--transfers-departure-requested': row.transfers.departure[0]?.status?.code === 'requested' || row.transfers.departure?.status?.code === 'need_amended'
            }"
          >
          </button>
          <button
            @click="onShowActivitiesModal(row, 'transfers', 'other')"
            type="button"
            class="table-default__activity table-default__activity--transfers-other table-default__activity--adds"
            :class="{
              'table-default__activity--active': row.transfers.other.length,
              'table-default__activity--transfers-other-length': row.transfers.other.length > 1,
              'table-default__activity--transfers-other-arranged': row.transfers.other[0]?.status?.code === 'arranged',
              'table-default__activity--transfers-other-cancelled': row.transfers.other[0]?.status?.code === 'cancelled',
              'table-default__activity--transfers-other-requested': row.transfers.other[0]?.status?.code === 'requested' || row.transfers.other?.status?.code === 'need_amended'
            }"
          >
          </button>
        </div>
      </template>
      <template #controls="{ row }">
        <div class="table-default__controls">
          <button @click="onShowDeleteModal(row)" type="button">
            <img src="@/assets/img/delete-table-icon.svg" alt="">
          </button>
        </div>
      </template>
    </v-client-table>
    <modal
      name="client-form"
      :width="700"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('client-form')" class="popup__close" type="button"></button>
        <div class="popup__title">Create client</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckForm">
            <app-grid>
              <template #item-1>
                <app-form-group label="Content language" required>
                  <app-select
                    v-model="form.content_language"
                    :options="languages_options"
                    :reduce="item => item.code"
                    :filterable="false"
                    :clearable="false"
                    :searchable="false"
                    placeholder="Content language"
                    :error="$v.form.content_language.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.content_language.$dirty && !$v.form.content_language.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="First name" label-for="first_name" required>
                  <app-input
                    v-model="form.first_name"
                    @change.native="$v.form.first_name.$touch()"
                    @input="onChangeRUToUS($event, 'first_name')"
                    :error="$v.form.first_name.$error"
                    id="first_name"
                    placeholder="First name"
                    name="first_name"
                  />
                  <template #error>
                    <div v-if="$v.form.first_name.$dirty && !$v.form.first_name.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Last name" label-for="last_name" required>
                  <app-input
                    v-model="form.last_name"
                    @change.native="$v.form.last_name.$touch()"
                    @input="onChangeRUToUS($event, 'last_name')"
                    :error="$v.form.last_name.$error"
                    id="last_name"
                    placeholder="Last name"
                    name="last_name"
                  />
                  <template #error>
                    <div v-if="$v.form.last_name.$dirty && !$v.form.last_name.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Gender">
                  <app-cells position="start" :indent="false">
                    <app-radio
                      v-for="item in genders_options"
                      :key="item.code"
                      v-model.number="form.gender"
                      :value="item.code"
                      name="gender"
                      :checked="form.gender"
                    >
                      <template #label>{{ item.name }}</template>
                    </app-radio>
                  </app-cells>
                </app-form-group>
              </template>
              <template #item-2>
                <app-form-group label="E-mail" label-for="email">
                  <app-input
                    v-model="form.email"
                    @change.native="$v.form.email.$touch"
                    :error="$v.form.email.$error"
                    id="email"
                    type="email"
                    placeholder="E-mail"
                    name="email"
                  />
                  <template #error>
                    <div v-if="$v.form.email.$dirty && !$v.form.email.email">Enter the correct e-mail format</div>
                  </template>
                </app-form-group>
                <app-form-group label="Phone">
                  <app-phone
                    @change.native="$v.form.phone.$touch()"
                    v-model="form.phone"
                    placeholder="+255 786 350 350"
                    :error="$v.form.phone.$dirty && form.phone === 0"
                  />
                  <template #error>
                    <div v-if="$v.form.phone.$dirty && form.phone === 0">
                      Invalid phone number format
                    </div>
                  </template>
                </app-form-group>
                <app-form-group label="Other communications" class="form-group--mb38">
                  <app-cells :indent="false">
                    <app-checkbox v-model="form.phone_telegram" label="Telegram" :readonly="!form.phone" />
                    <app-checkbox v-model="form.phone_whatsapp" label="Whatsapp" :readonly="!form.phone" />
                  </app-cells>
                </app-form-group>
              </template>
            </app-grid>
            <app-cells position="center" :indent="false">
              <app-button :disabled="$v.form.$error || form.phone === 0" type="submit" ref="submit">Create</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
      name="activities-modal"
      :width="800"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="onHideModalActivities" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <template v-if="activities_modal_type === 'climbing'">
            <img src="@/assets/img/climbing-modal-icon.svg" alt="Climbing">
            <span>Climbing</span>
          </template>
          <template v-if="activities_modal_type === 'safari'">
            <img src="@/assets/img/safari-modal-icon.svg" alt="Safari">
            <span>Safari</span>
          </template>
          <template v-if="activities_modal_type === 'transfers'">
            <template v-if="activities_modal_transfer_type === 'arrival'">
              <img src="@/assets/img/arrival-modal-icon.svg" alt="Transfers">
              <span>Arrival transfer</span>
            </template>
            <template v-if="activities_modal_transfer_type === 'departure'">
              <img src="@/assets/img/departure-modal-icon.svg" alt="Transfers">
              <span>Departure transfer</span>
            </template>
            <template v-if="activities_modal_transfer_type === 'other'">
              <img src="@/assets/img/other-modal-icon.svg" alt="Transfers">
              <span>Other transfers</span>
            </template>
          </template>
          <template v-if="activities_modal_type === 'day_trips'">
            <img src="@/assets/img/day-trips-modal-icon.svg" alt="Day trips">
            <span>Day trip</span>
          </template>
          <template v-if="activities_modal_type === 'free_days'">
            <img src="@/assets/img/free-days-modal-icon.svg" alt="Free days">
            <span>Free days</span>
          </template>
          <template v-if="activities_modal_type === 'island_vacation_groups'">
            <img src="@/assets/img/island-modal-icon.svg" alt="Free days">
            <span>Island vacation </span>
          </template>
        </div>
        <div class="popup__body">
          <div class="popup__activities">
            <div
              v-for="activity of activities_modal_data"
              :key="activity.id"
              class="popup__activity"
            >
              <div class="popup__activity-info">
                <template v-if="['day_trips', 'climbing'].includes(activities_modal_type)">
                  <div class="popup__activity-row popup__activity-row--single">
                    <div class="popup__activity-values">
                      <span>Group Name:</span>
                      <router-link
                        v-if="activities_modal_type === 'climbing'"
                        :to="{name: 'climbing-groups-detail', params: {id: activity.group.id}}"
                        class="popup__activity-link"
                      >
                        {{ activity.group.name }}
                      </router-link>
                      <router-link
                        v-if="activities_modal_type === 'day_trips'"
                        :to="{name: 'day-trips-groups-detail', params: {id: activity.id}}"
                        class="popup__activity-link"
                      >
                        {{ activity.name }}
                      </router-link>
                    </div>
                  </div>
                </template>
                <template v-if="activities_modal_type === 'safari'">
                  <div class="popup__activity-row popup__activity-row--single">
                    <div class="popup__activity-values">
                      <span>Group Name:</span>
                      <router-link
                        :to="{name: 'safari-groups-detail', params: {id: activity.group.id}}"
                        class="popup__activity-link"
                      >
                        {{ activity.group.name }}
                      </router-link>
                    </div>
                  </div>
                </template>
                <div v-if="activities_modal_type === 'climbing'" class="popup__activity-row">
                  <div class="popup__activity-values">
                    <span>Mount:</span>
                    <span>{{ activity.group.route.mountain.name }}</span>
                  </div>
                  <div class="popup__activity-values">
                    <span>Route:</span>
                    <span>{{ activity.group.route.name }}</span>
                  </div>
                </div>
                <div v-if="activities_modal_type === 'day_trips'" class="popup__activity-row popup__activity-row--single">
                  <div class="popup__activity-values popup__activity-values--center">
                    <span>Date:</span>
                    <span>{{ dateFormat(activity.date) }} {{ activity.pick_up_time }}</span>
                    <span
                      v-if="activity.pick_up_time_to_be_confirmed"
                      class="status-tag"
                      :style="{ 'backgroundColor': '#f0c427', 'color': '#fff' }"
                    >
                      To be confirmed
                    </span>
                  </div>
                </div>
                <div v-if="activities_modal_type === 'day_trips'" class="popup__activity-row">
                  <div class="popup__activity-values">
                    <span>Pick-up:</span>
                    <span>{{ activity.pick_up_location ? activity.pick_up_location.short_name : '-' }}</span>
                  </div>
                </div>
                <div v-if="activities_modal_type === 'day_trips'" class="popup__activity-row">
                  <div class="popup__activity-values">
                    <span>Activity:</span>
                    <span>{{ activity.activity.short_name }}</span>
                  </div>
                </div>
                <div v-if="activities_modal_type === 'safari'" class="popup__activity-row">
                  <div class="popup__activity-values">
                    <span>Tour start:</span>
                    <span>{{ dateFormat(activity.group.tour_start) }}</span>
                  </div>
                  <div class="popup__activity-values">
                    <span>Tour finish:</span>
                    <span>{{ dateFormat(activity.group.tour_end) }}</span>
                  </div>
                  <div class="popup__activity-values">
                    <span>Duration:</span>
                    <span>{{ activity.group.duration }} days</span>
                  </div>
                </div>
                <div v-if="activities_modal_type === 'climbing'" class="popup__activity-row">
                  <div class="popup__activity-values">
                    <span>Tour start:</span>
                    <span>{{ dateFormat(activity.group.tour_start) }}</span>
                  </div>
                  <div class="popup__activity-values">
                    <span>Tour finish:</span>
                    <span>{{ dateFormat(activity.group.tour_end) }}</span>
                  </div>
                  <div class="popup__activity-values">
                    <span>Duration:</span>
                    <span>{{ activity.group.route.duration }} days</span>
                  </div>
                </div>
                <template v-if="activities_modal_type === 'island_vacation_groups'">
                  <div class="popup__activity-row">
                    <div class="popup__activity-values">
                      <span>Group name:</span>
                      <span>{{ activity.name }}</span>
                    </div>
                  </div>
                  <div class="popup__activity-row">
                    <div class="popup__activity-values">
                      <span>Tour start:</span>
                      <span>{{ dateFormat(activity.tour_start) }}</span>
                    </div>
                  </div>
                  <div class="popup__activity-row">
                    <div class="popup__activity-values">
                      <span>Tour end:</span>
                      <span>{{ dateFormat(activity.tour_end) }}</span>
                    </div>
                  </div>
                </template>
                <template v-if="activities_modal_type === 'free_days'">
                  <div class="popup__activity-row">
                    <div class="popup__activity-values">
                      <span>From:</span>
                      <span>{{ dateFormat(activity.tour_start) }}</span>
                    </div>
                    <div class="popup__activity-values">
                      <span>To:</span>
                      <span>{{ dateFormat(activity.tour_end) }}</span>
                    </div>
                  </div>
                  <div class="popup__activity-row popup__activity-row--single">
                    <div class="popup__activity-values">
                      <span>Location:</span>
                      <span>{{ activity.location.short_name }}</span>
                    </div>
                  </div>
                </template>
                <template v-if="activities_modal_type === 'transfers'">
                  <div class="popup__activity-row popup__activity-row--double">
                    <div class="popup__activity-values">
                      <span>Pick-up date:</span>
                      <span>{{ dateFormat(activity.pick_up_date) }} {{ activity.pick_up_time }}</span>
                    </div>
                    <div class="popup__activity-values">
                      <span>Pick-up point:</span>
                      <span>{{ activity.pick_up_point?.short_name }}</span>
                    </div>
                  </div>
                  <div class="popup__block-route popup__activity-row">
                    <span class="popup__activity-key">Points:</span>
                    <span>{{ activity.pick_up_point.short_name }}</span>
                    <img src="@/assets/img/arrow-right-gray-icon.svg" alt="">
                    <span v-for="(point, index) in activity.points" :key="point.id" class="popup__block-route-group">
                      <span>{{ point.location.short_name }}</span>
                      <img v-if="index !== activity.points.length - 1" src="@/assets/img/arrow-right-gray-icon.svg" alt="">
                    </span>
                  </div>
                  <div class="popup__activity-row popup__activity-row--single">
                    <div class="popup__activity-values popup__activity-values--center">
                      <span>Status:</span>
                      <span
                        class="status-tag"
                        :style="{ 'backgroundColor': activity.status.code === 'need_amended' || activity.status.code === 'requested' ? '#eec82d' : activity.status.code === 'arranged' ? '#77b017' : '#bcbcbc', 'color': '#fff' }"
                      >
                        {{ activity.status.name }}
                      </span>
                    </div>
                  </div>
                </template>
              </div>
              <div v-if="activities_modal_type === 'climbing'" class="popup__adds">
                <div class="popup__add">
                  <div class="popup__add-name">
                    <img src="@/assets/img/checklist-icon.svg" alt="Checklist">
                    <span>Equipment checklist</span>
                    <a
                      v-if="is_general_manager || is_sales_manager || is_sales_supervisor"
                      :href="`${family_url}${client_hash}/rentals/${activity.group.id}`"
                      target="_blank"
                      class="popup__activity-external"
                    ></a>
                  </div>
                  <img v-if="activity.checklist.completed" src="@/assets/img/modal-complete-icon.svg" alt="Complete">
                  <img v-else src="@/assets/img/modal-out-icon.svg" alt="Out">
                </div>
<!--                  <div class="popup__add">-->
<!--                    <div class="popup__add-name">-->
<!--                      <img src="@/assets/img/services-modal-icon.svg" alt="Services">-->
<!--                      <span>Additional services</span>-->
<!--                    </div>-->
<!--                    &lt;!&ndash;                  <img src="@/assets/img/modal-complete-icon.svg" alt="Complete">&ndash;&gt;-->
<!--                    <img src="@/assets/img/modal-out-icon.svg" alt="Out">-->
<!--                  </div>-->
              </div>
              <div v-if="activities_modal_type === 'safari'" class="popup__add popup__add--col">
                <div class="popup__add-top">
                  <div class="popup__add-name">
                    <img src="@/assets/img/food-modal-icon.svg" alt="Services">
                    <span>Snack bar</span>
                    <a
                      :href="`${family_url}${client_hash}/snacks/${activity.hash}`"
                      target="_blank"
                      class="popup__activity-external"
                    ></a>
                  </div>
                  <div class="popup__add-info">
                    <img v-if="!activity.snack_bar" src="@/assets/img/clock-snacks.svg" alt="Out">
                    <template v-else>
                      <img v-if="!activity.snack_bar.completed" src="@/assets/img/modal-notcomplete-icon.svg" alt="Notcomplete">
                      <img v-if="activity.snack_bar.no_need" src="@/assets/img/modal-noneed-icon.svg" alt="Noneed">
                      <img v-if="activity.snack_bar.completed && activity.snack_bar.outstanding_amount === 0" src="@/assets/img/modal-complete-icon.svg" alt="Complete">
                      <img v-if="activity.snack_bar.completed && activity.snack_bar.outstanding_amount > 0" src="@/assets/img/modal-usd-icon.svg" alt="USD">
                    </template>
                  </div>
                </div>
                <div v-if="activity.snack_bar.completed && activity.snack_bar.outstanding_amount >= 0" class="popup__add-values">
                  <div class="popup__add-value">
                    <span>Items:</span>
                    <span>{{ activity.snack_bar.items_count }}</span>
                  </div>
                  <div class="popup__add-value">
                    <span>Order amount:</span>
                    <span>{{ activity.snack_bar.order_amount.toLocaleString() }}$</span>
                  </div>
                  <div class="popup__add-value">
                    <span>Credit:</span>
                    <span>{{ activity.snack_bar.credit.toLocaleString() }}$</span>
                  </div>
                  <div v-if="activity.snack_bar.completed && activity.snack_bar.outstanding_amount > 0" class="popup__add-value">
                    <span>Outstanding amount:</span>
                    <span>{{ activity.snack_bar.outstanding_amount.toLocaleString() }}$</span>
                  </div>
                </div>
              </div>
            </div>
<!--            <div v-if="activities_modal_type === 'climbing'" class="popup__activity popup__activity&#45;&#45;medical">-->
<!--              <div class="popup__activity-holder">-->
<!--                <div class="popup__activity-name">-->
<!--                  <img src="@/assets/img/modal-medical-form.svg" alt="Medical">-->
<!--                  <span>Medical clearance form</span>-->
<!--                  <a :href="`${family_url}${client_hash}/medical`" target="_blank" class="popup__activity-external"></a>-->
<!--                </div>-->
<!--              </div>-->
<!--              <img v-if="medical_clearance_present" src="@/assets/img/modal-complete-icon.svg" alt="Complete">-->
<!--              <img v-else src="@/assets/img/modal-out-icon.svg" alt="Out">-->
<!--            </div>-->
          </div>
        </div>
      </div>
    </modal>
    <modal
      name="delete-modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('delete-modal')" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/warning-round-icon.svg" alt="">
          Delete Record
        </div>
        <div class="popup__body">
          <div class="popup__subt">Are you sure you want to delete this client?</div>
          <div v-if="client_to_delete" class="popup__info">{{ client_to_delete.full_name }}</div>
          <app-cells position="center" :indent="false">
            <app-button @click.native="$modal.hide('delete-modal')" theme="dark">Cancel</app-button>
            <app-button @click.native="onDeleteClient" ref="delete_button">Yes</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
    <modal
      name="add-group-form"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('add-group-form')" class="popup__close" type="button"></button>
        <div class="popup__title">Adding clients to {{ modal_type_add === 'climbing' ? 'climbing' : 'safari' }} group</div>
        <div class="popup__body">
          <form @submit.prevent="checkAddClientsForm">
            <app-cells>
              Create new group <app-switcher v-model="create_new_group" />
            </app-cells>
            <template v-if="modal_type_add === 'climbing'">
              <template v-if="create_new_group">
                <app-form-group label="Group name" label-for="group_name_climbing" required>
                  <app-input
                    v-model="add_clients_form.climbing_name"
                    :error="$v.add_clients_form.climbing_name.$error"
                    id="group_name_climbing"
                    placeholder="Group name"
                    name="group_name_climbing"
                  />
                  <template #error>
                    <div v-if="$v.add_clients_form.climbing_name.$dirty && !$v.add_clients_form.climbing_name.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Route" required>
                  <app-select
                    v-model="add_clients_form.route"
                    :reduce="item => item.id"
                    :options="routes_options"
                    :clearable="false"
                    :display-field="option => `${option.name} ${option.duration}`"
                    label="route_duration"
                    placeholder="Route"
                    :error="$v.add_clients_form.route.$error"
                  />
                  <template #error>
                    <div v-if="$v.add_clients_form.route.$dirty && !$v.add_clients_form.route.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Type" required>
                  <app-select
                    v-model="add_clients_form.climbing_type"
                    :reduce="item => item.code"
                    :options="group_type_options_climbing"
                    :clearable="false"
                    placeholder="Type"
                    :error="$v.add_clients_form.climbing_type.$error"
                  />
                  <template #error>
                    <div v-if="$v.add_clients_form.climbing_type.$dirty && !$v.add_clients_form.climbing_type.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Tour start" required>
                  <app-date-picker
                    v-model="add_clients_form.climbing_tour_start"
                    placeholder="Tour start"
                    :error="$v.add_clients_form.climbing_tour_start.$error"
                  />
                  <template #error>
                    <div v-if="$v.add_clients_form.climbing_tour_start.$dirty && !$v.add_clients_form.climbing_tour_start.required">Required field</div>
                  </template>
                </app-form-group>
              </template>
              <template v-else>
                <app-form-group label="Tour start">
                  <app-date-picker
                    @input="onSelectClimbingStart"
                    v-model="add_climbing_tour_start"
                    placeholder="Tour start"
                  />
                </app-form-group>
                <app-form-group v-if="add_climbing_tour_start" label="Climbing group" required>
                  <app-select
                    v-model="add_clients_form.climbing_group"
                    :options="groups_options"
                    :clearable="false"
                    :display-field="option => `${option.name} - ${option.route.name} ${option.route.duration } (${option.type.name}) (${dateFormat(option.tour_start)} - ${dateFormat(option.tour_end) })`"
                    placeholder="Climbing group"
                    :error="$v.add_clients_form.climbing_group.$error"
                  />
                  <template #error>
                    <div v-if="$v.add_clients_form.climbing_group.$dirty && !$v.add_clients_form.climbing_group.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group v-else label="Climbing group" required>
                  <app-select
                    @search="onClimbingGroupSearch"
                    v-model="add_clients_form.climbing_group"
                    :options="groups_search_options"
                    :clearable="false"
                    :display-field="option => `${option.name} - ${option.route.name} ${option.route.duration} (${option.type.name }) (${dateFormat(option.tour_start)} - ${dateFormat(option.tour_end)})`"
                    placeholder="Climbing group"
                    :error="$v.add_clients_form.climbing_group.$error"
                  />
                  <template #error>
                    <div v-if="$v.add_clients_form.climbing_group.$dirty && !$v.add_clients_form.climbing_group.required">Required field</div>
                  </template>
                </app-form-group>
              </template>
            </template>
            <app-cells position="center" :indent="false">
              <app-button
                :disabled="$v.add_clients_form.$error"
                type="submit"
                ref="clientAddSubmit"
              >
                Add clients
              </app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
        name="day-trip-modal"
        :width="400"
        :height="'auto'"
        :scrollable="true"
        :adaptive="true"
        :clickToClose="false"
        class="modal-not-overflow"
        draggable=".popup__title"
        :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('day-trip-modal')" class="popup__close" type="button"></button>
        <div v-if="create_new_group" class="popup__title">Creating day trip</div>
        <div v-else class="popup__title">Adding clients to day trip group</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckDayTripForm">
            <app-cells>
              Create new group <app-switcher v-model="create_new_group" />
            </app-cells>
            <template v-if="create_new_group">
              <app-form-group label="Group name" label-for="group_name_day_trip" required>
                <app-input
                    v-model="day_trip_form.name"
                    :error="$v.day_trip_form.name.$error"
                    id="group_name_day_trip"
                    placeholder="Group name"
                    name="group_name_day_trip"
                />
                <template #error>
                  <div v-if="$v.day_trip_form.name.$dirty && !$v.day_trip_form.name.required">Required field</div>
                </template>
              </app-form-group>
              <app-form-group label="Activity" required>
                <app-select
                  v-model="day_trip_form.activity"
                  :reduce="item => item.id"
                  :options="day_trips_activity_options"
                  :clearable="false"
                  placeholder="Type"
                  :error="$v.day_trip_form.activity.$error"
                />
                <template #error>
                  <div v-if="$v.day_trip_form.activity.$dirty && !$v.day_trip_form.activity.required">Required field</div>
                </template>
              </app-form-group>
              <app-form-group label="Date" required>
                <app-date-picker
                  v-model="day_trip_form.date"
                  placeholder="Tour start"
                  :error="$v.day_trip_form.date.$error"
                />
                <template #error>
                  <div v-if="$v.day_trip_form.date.$dirty && !$v.day_trip_form.date.required">Required field</div>
                </template>
              </app-form-group>
              <app-form-group label="Pick-up location" required>
                <app-select
                  @input="onLocationSelected"
                  @search="onLocationSearch"
                  v-model="day_trip_form.pick_up_location"
                  :options="location_options"
                  :clearable="false"
                  placeholder="Pick-up location"
                  :error="$v.day_trip_form.pick_up_location.$error"
                />
                <template #error>
                  <div v-if="$v.day_trip_form.pick_up_location.$dirty && !$v.day_trip_form.pick_up_location.required">Required field</div>
                </template>
              </app-form-group>
              <app-form-group label="Pick-up time" label-for="pick_up_time" required>
                <app-input
                    v-model="day_trip_form.pick_up_time"
                    v-mask="'99:99'"
                    placeholder="Time"
                    autocomplete="off"
                    id="pick_up_time-time"
                    name="pick_up_time"
                    @paste.native.prevent
                    :error="$v.day_trip_form.pick_up_time.$error"
                />
                <template #error>
                  <div v-if="$v.day_trip_form.pick_up_time.$dirty && !$v.day_trip_form.pick_up_time.required">Required field</div>
                  <div v-if="$v.day_trip_form.pick_up_time.$dirty && !$v.day_trip_form.pick_up_time.timeRegex">Wrong time</div>
                </template>
              </app-form-group>
              <app-cells>
                Pick-up time to be confirmed <app-switcher v-model="day_trip_form.pick_up_time_to_be_confirmed" />
              </app-cells>
              <app-cells>
                Ready to join <app-switcher v-model="day_trip_form.ready_to_join" />
              </app-cells>
            </template>
            <app-form-group v-else label="Day trip group" required>
              <app-select
                v-model="day_trip_form.group"
                :reduce="item => item.id"
                :options="day_trip_groups_options"
                :clearable="false"
                placeholder="Day trip group"
                :error="$v.day_trip_form.group.$error"
              />
              <template #error>
                <div v-if="$v.day_trip_form.group.$dirty && !$v.day_trip_form.group.required">Required field</div>
              </template>
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button :disabled="$v.day_trip_form.$error" type="submit" ref="day_trip_submit">
                {{ create_new_group ? 'Create day trip' : 'Add clients' }}
              </app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
      name="add-group-safari-form"
      :width="700"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('add-group-safari-form')" class="popup__close" type="button"></button>
        <div class="popup__title">Adding clients to safari group</div>
        <div class="popup__body">
          <form @submit.prevent="checkAddClientsSafariForm">
            <app-cells>
              <app-radio
                @change="onChangeTypeSafariRes"
                v-for="radio of type_safari_res_options"
                :key="radio.label"
                v-model="type_safari_res"
                :value="radio.value"
                :checked="type_safari_res === radio.value"
                name="type_safari_res"
              >
                <template #label>{{ radio.label }}</template>
              </app-radio>
            </app-cells>
            <template v-if="type_safari_res === 'gamepackage'">
              <app-grid>
                <template #item-1>
                  <app-form-group label="Cars" label-for="safari_cars" required>
                    <app-input
                      v-model.number="add_clients_form_safari.cars_required"
                      :error="$v.add_clients_form_safari.cars_required.$error"
                      id="safari_cars"
                      type="number"
                      min="0"
                      placeholder="Cars required"
                    />
                    <template #error>
                      <div v-if="$v.add_clients_form_safari.cars_required.$dirty && !$v.add_clients_form_safari.cars_required.required">Required field</div>
                    </template>
                  </app-form-group>
                  <app-form-group label="Group name" label-for="group_name" required>
                    <app-input
                      v-model="add_clients_form_safari.name"
                      :error="$v.add_clients_form_safari.name.$error"
                      id="group_name"
                      placeholder="Group name"
                      name="group_name"
                    />
                    <template #error>
                      <div v-if="$v.add_clients_form_safari.name.$dirty && !$v.add_clients_form_safari.name.required">Required field</div>
                    </template>
                  </app-form-group>
                  <app-form-group label="Tour start" required>
                    <app-date-picker
                      @input="onSetTourStart"
                      v-model="add_clients_form_safari.tour_start"
                      placeholder="Tour start"
                      :error="$v.add_clients_form_safari.tour_start.$error"
                    />
                    <template #error>
                      <div v-if="$v.add_clients_form_safari.tour_start.$dirty && !$v.add_clients_form_safari.tour_start.required">Required field</div>
                    </template>
                  </app-form-group>
                  <app-form-group label="Tour finish" required>
                    <app-date-picker
                      v-model="add_clients_form_safari.tour_end"
                      :readonly="!add_clients_form_safari.tour_start"
                      :default-value="add_clients_form_safari.tour_start"
                      placeholder="Tour finish"
                      ref="tour_end"
                      :error="$v.add_clients_form_safari.tour_end.$error"
                    />
                    <template #error>
                      <div v-if="$v.add_clients_form_safari.tour_end.$dirty && !$v.add_clients_form_safari.tour_end.required">Required field</div>
                    </template>
                  </app-form-group>
                </template>
                <template #item-2>
                  <app-form-group label="Short itinerary" label-for="short_itinerary" required>
                    <app-input
                      v-model="add_clients_form_safari.short_itinerary"
                      id="short_itinerary"
                      placeholder="Tar, Ngo, 2Ser"
                      name="short_itinerary"
                      :error="$v.add_clients_form_safari.short_itinerary.$error"
                    />
                    <template #error>
                      <div v-if="$v.add_clients_form_safari.short_itinerary.$dirty && !$v.add_clients_form_safari.short_itinerary.required">Required field</div>
                    </template>
                  </app-form-group>
                  <app-form-group label="Start from">
                    <app-select
                      @input="onLocationStartSelected"
                      @search="onLocationSearch"
                      v-model="add_clients_form_safari.start_from"
                      :options="location_options"
                      placeholder="Select"
                    />
                  </app-form-group>
                  <app-form-group label="Finish at">
                    <app-select
                      @input="onLocationFinishSelected"
                      @search="onLocationFinishSearch"
                      v-model="add_clients_form_safari.finish_at"
                      :options="location_finish_options"
                      placeholder="Select"
                    />
                  </app-form-group>
                </template>
              </app-grid>
            </template>
            <template v-if="type_safari_res === 'reservation'">
              <app-form-group label="Group name" label-for="group_name" required>
                <app-input
                  v-model="add_clients_form_safari.group_name"
                  :error="$v.add_clients_form_safari.group_name.$error"
                  id="group_name"
                  placeholder="Group name"
                  name="group_name"
                />
                <template #error>
                  <div v-if="$v.add_clients_form_safari.group_name.$dirty && !$v.add_clients_form_safari.group_name.required">Required field</div>
                </template>
              </app-form-group>
              <app-form-group label="Reservation" required>
                <app-select
                  v-model="add_clients_form_safari.reservation"
                  :reduce="item => item.id"
                  :options="safari_reservations_options"
                  :display-field="option => `${dateFormat(option.tour_start)} - ${dateFormat(option.tour_end)} (${option.short_itinerary})`"
                  :clearable="false"
                  label="id"
                  placeholder="Reservation"
                  :error="$v.add_clients_form_safari.reservation.$error"
                />
                <template #error>
                  <div v-if="$v.add_clients_form_safari.reservation.$dirty && !$v.add_clients_form_safari.reservation.required">Required field</div>
                </template>
              </app-form-group>
            </template>
            <app-form-group v-if="type_safari_res === 'add_to_group'" label="Safari group" required>
              <app-select
                @search="onGroupSafariSearch"
                v-model="add_clients_form_safari.group"
                :options="groups_options"
                :filterable="false"
                :clearable="false"
                :display-field="option => `${option.name} - ${option.id} (${dateFormat(option.tour_start)} - ${dateFormat(option.tour_end)})`"
                placeholder="Safari group"
                :error="$v.add_clients_form_safari.group.$error"
              />
              <template #error>
                <div v-if="$v.add_clients_form_safari.group.$dirty && !$v.add_clients_form_safari.group.required">Required field</div>
              </template>
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button
                :disabled="$v.add_clients_form_safari.$error"
                type="submit"
                ref="clientAddSafariSubmit"
              >
                Add clients
              </app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
        name="transfer-modal"
        :width="500"
        :height="'auto'"
        :scrollable="true"
        :adaptive="true"
        :clickToClose="false"
        class="modal-not-overflow"
        draggable=".popup__title"
        :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('transfer-modal')" class="popup__close" type="button"></button>
        <div class="popup__title">Request other transfer ({{ checked.length }} Pax)</div>
        <div class="popup__subt">For arrival & departure use another form</div>
        <div v-if="transfer_form" class="popup__body">
          <form @submit.prevent="onCheckTransferForm">
            <div class="arrival-popup">
              <app-form-group label="Name" label-for="tr_name" required>
                <app-input
                    v-model="transfer_form.name"
                    placeholder="Name"
                    id="name"
                    name="tr_name"
                    :error="$v.transfer_form.name.$error"
                />
                <template #error>
                  <div v-if="$v.transfer_form.name.$dirty && !$v.transfer_form.name.required">Required field</div>
                </template>
              </app-form-group>
              <app-grid>
                <template #item-1>
                  <app-form-group label="Pick-up date" required>
                    <app-date-picker
                      v-model="transfer_form.pick_up_date"
                      placeholder="Specify a date"
                      :error="$v.transfer_form.pick_up_date.$error"
                    />
                    <template #error>
                      <div v-if="$v.transfer_form.pick_up_date.$dirty && !$v.transfer_form.pick_up_date.required">Required field</div>
                      <div v-if="$v.transfer_form.pick_up_date.$dirty && !$v.transfer_form.pick_up_date.minValue">
                        Date cannot be less than the current date
                      </div>
                    </template>
                  </app-form-group>
                </template>
                <template #item-2>
                  <app-form-group label="Pick-up time" label-for="pick_up_time" required>
                    <app-input
                        v-model="transfer_form.pick_up_time"
                        v-mask="'99:99'"
                        placeholder="Time"
                        autocomplete="off"
                        id="pick_up_time-time"
                        name="pick_up_time"
                        @paste.native.prevent
                        :error="$v.transfer_form.pick_up_time.$error"
                    />
                    <template #error>
                      <div v-if="$v.transfer_form.pick_up_time.$dirty && !$v.transfer_form.pick_up_time.required">Required field</div>
                      <div v-if="$v.transfer_form.pick_up_time.$dirty && !$v.transfer_form.pick_up_time.timeRegex">Wrong time</div>
                    </template>
                  </app-form-group>
                </template>
              </app-grid>
              <app-form-group label="Pick-up point" required>
                <app-select
                  @input="onTransferPickUpPointSelected(transfer_form.pick_up_point)"
                  @search="onLocationSearch"
                  v-model="transfer_form.pick_up_point"
                  :options="location_options"
                  :filterable="false"
                  :clearable="false"
                  placeholder="Select"
                  :error="$v.transfer_form.pick_up_point.$error"
                />
                <template #error>
                  <div v-if="$v.transfer_form.pick_up_point.$dirty && !$v.transfer_form.pick_up_point.required">Required field</div>
                </template>
              </app-form-group>
              <draggable
                  :list="transfer_form.points"
                  v-bind="dragOptions"
                  handle=".sortable__handle"
                  class="transfer-sortable transfer-sortable--lite"
              >
                <transition-group type="transition" :name="'flip-list'" tag="div">
                  <div v-for="(element, index) in transfer_form.points" :key="`transfer_points_${index}`" class="transfer-sortable__item">
                    <div class="transfer-sortable__row">
                      <app-form-group :label="`Destination ${index + 1}`" class="form-group--no-indent" required>
                        <app-select
                          @input="onTransferLocationSelected(element.location, index)"
                          @search="onLocationSearch"
                          v-model="element.location"
                          :options="location_options"
                          :filterable="false"
                          :clearable="false"
                          placeholder="Select"
                          :error="$v.transfer_form.points.$each[index].location.$error"
                        />
                        <template #error>
                          <div v-if="$v.transfer_form.points.$each[index].location.$dirty && !$v.transfer_form.points.$each[index].location.required">Required field</div>
                        </template>
                      </app-form-group>
                      <button type="button" class="transfer-sortable__btn sortable__handle">
                        <img src="@/assets/img/sortable-arrow.svg" alt="Arrow">
                      </button>
                      <button
                          v-if="index !== 0"
                          @click="onRemoveTransferDestination(index)"
                          class="transfer-sortable__close"
                          type="button"
                      >
                        <img src="@/assets/img/delete-transfer.svg" alt="Delete">
                      </button>
                    </div>
                  </div>
                </transition-group>
              </draggable>
              <app-cells>
                <app-button @click.native="onAddTransferDestination" size="small">
                  <img src="@/assets/img/plus-icon.svg" alt="Add">
                  <span>Add destination</span>
                </app-button>
              </app-cells>
              <app-form-group label="Notes" label-for="notes">
                <app-textarea
                    v-model="transfer_form.notes"
                    id="notes"
                    placeholder="Notes"
                />
              </app-form-group>
            </div>
            <app-cells position="center" :indent="false">
              <app-button type="submit" ref="transfer_submit">Request transfer</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
      name="free-day-modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      draggable=".popup__title"
      class="modal-not-overflow"
    >
      <div class="popup">
        <button @click="$modal.hide('free-day-modal')" class="popup__close" type="button"></button>
        <div class="popup__title">Create free day</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckFreeForm">
            <app-cells>
              Create new group <app-switcher v-model="create_new_group_free" />
            </app-cells>
            <template v-if="create_new_group_free">
              <app-form-group label="Group name" label-for="group_name_free" required>
                <app-input
                  v-model="free_form.name"
                  :error="$v.free_form.name.$error"
                  id="group_name_free"
                  placeholder="Group name"
                  name="group_name_free"
                />
                <template #error>
                  <div v-if="$v.free_form.name.$dirty && !$v.free_form.name.required">Required field</div>
                </template>
              </app-form-group>
              <app-form-group label="Location" required>
                <app-select
                  @input="onFreeLocationSelected"
                  @search="onLocationSearch"
                  v-model="free_form.location"
                  :options="location_options"
                  :clearable="false"
                  placeholder="Location"
                  :error="$v.free_form.location.$error"
                />
                <template #error>
                  <div v-if="$v.free_form.location.$dirty && !$v.free_form.location.required">Required field</div>
                </template>
              </app-form-group>
              <app-form-group label="From" required>
                <app-date-picker
                  @input="onSetFreeStart"
                  v-model="free_form.tour_start"
                  placeholder="From"
                  :error="$v.free_form.tour_start.$error"
                />
                <template #error>
                  <div v-if="$v.free_form.tour_start.$dirty && !$v.free_form.tour_start.required">Required field</div>
                </template>
              </app-form-group>
              <app-form-group label="To" required>
                <app-date-picker
                  v-model="free_form.tour_end"
                  :readonly="!free_form.tour_start"
                  :default-value="free_form.tour_start"
                  placeholder="To"
                  ref="free_tour_end"
                  :error="$v.free_form.tour_end.$error"
                />
                <template #error>
                  <div v-if="$v.free_form.tour_end.$dirty && !$v.free_form.tour_end.required">Required field</div>
                </template>
              </app-form-group>
              <app-form-group label="Notes" label-for="notes_free">
                <app-textarea
                  v-model="free_form.notes"
                  id="notes_free"
                  placeholder="Notes"
                />
              </app-form-group>
            </template>
            <app-form-group v-else label="Free days" required>
              <app-select
                v-model="free_form.group"
                :options="free_days_options"
                :clearable="false"
                :display-field="option => `${option.name} - ${dateFormat(option.date)}`"
                placeholder="Select"
                :error="$v.free_form.group.$error"
              />
              <template #error>
                <div v-if="$v.free_form.group.$dirty && !$v.free_form.group.required">Required field</div>
              </template>
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button type="submit" ref="free_submit" :disabled="$v.free_form.$error">Create</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
      name="island-modal"
      :width="750"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      draggable=".popup__title"
      class="modal-not-overflow"
    >
      <div class="popup">
        <button @click="$modal.hide('island-modal')" class="popup__close" type="button"></button>
        <div class="popup__title">Create island vacation</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckIslandForm">
            <app-cells>
              Create new group <app-switcher v-model="create_new_group_island" />
            </app-cells>
            <template v-if="create_new_group_island">
              <div class="popup__cols popup__cols--3">
                <app-form-group label="Group name" label-for="group_name_free" required>
                  <app-input
                    v-model="island_form.name"
                    :error="$v.island_form.name.$error"
                    id="group_name_free"
                    placeholder="Group name"
                    name="group_name_free"
                  />
                  <template #error>
                    <div v-if="$v.island_form.name.$dirty && !$v.island_form.name.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Tour start" required>
                  <app-date-picker
                    @input="onSetIslandStart"
                    v-model="island_form.tour_start"
                    placeholder="Tour start"
                    :error="$v.island_form.tour_start.$error"
                  />
                  <template #error>
                    <div v-if="$v.island_form.tour_start.$dirty && !$v.island_form.tour_start.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Tour finish" required>
                  <app-date-picker
                    v-model="island_form.tour_end"
                    :readonly="!island_form.tour_start"
                    :default-value="island_form.tour_start"
                    placeholder="Tour finish"
                    ref="island_tour_end"
                    :error="$v.island_form.tour_end.$error"
                  />
                  <template #error>
                    <div v-if="$v.island_form.tour_end.$dirty && !$v.island_form.tour_end.required">Required field</div>
                  </template>
                </app-form-group>
              </div>
              <app-form-group label="Itinerary description">
                <vue-editor v-model="island_form.itinerary_description" :editor-toolbar="custom_toolbar" />
              </app-form-group>
            </template>
            <app-form-group v-else label="Island vacation" required>
              <app-select
                v-model="island_form.group"
                :options="island_vacation_groups"
                :clearable="false"
                :display-field="option => `${option.name} (${dateFormat(option.tour_start)} - ${dateFormat(option.tour_end) })`"
                placeholder="Select"
                :error="$v.island_form.group.$error"
              />
              <template #error>
                <div v-if="$v.island_form.group.$dirty && !$v.island_form.group.required">Required field</div>
              </template>
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button type="submit" ref="island_submit" :disabled="$v.island_form.$error">Create</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
        name="transfer-clients-form"
        :width="400"
        :height="'auto'"
        :scrollable="true"
        :adaptive="true"
        :clickToClose="false"
        class="modal-not-overflow"
        draggable=".popup__title"
        :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('transfer-clients-form')" class="popup__close" type="button"></button>
        <div class="popup__title">Transfer clients to another group</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckTransferClientsForm">
            <app-cells>
              Create new group <app-switcher v-model="create_new_group" />
            </app-cells>
            <template v-if="create_new_group">
              <app-form-group label="Lead name" label-for="lead_name_transfer_clients" required>
                <app-input
                  v-model="transfer_clients_form.lead_name"
                  :error="$v.transfer_clients_form.lead_name.$error"
                  id="lead_name_transfer_clients"
                  placeholder="Lead name"
                  name="lead_name_transfer_clients"
                />
                <template #error>
                  <div v-if="$v.transfer_clients_form.lead_name.$dirty && !$v.transfer_clients_form.lead_name.required">Required field</div>
                </template>
              </app-form-group>
              <app-form-group label="Lead status" required>
                <app-select
                  v-model="transfer_clients_form.status"
                  :options="lead_status_options"
                  :reduce="item => item.code"
                  :clearable="false"
                  placeholder="Lead status"
                  :error="$v.transfer_clients_form.status.$error"
                />
                <template #error>
                  <div v-if="$v.transfer_clients_form.status.$dirty && !$v.transfer_clients_form.status.required">Required field</div>
                </template>
              </app-form-group>
              <app-form-group label="Group name" label-for="group_name_transfer_clients" required>
                <app-input
                    v-model="transfer_clients_form.group_name"
                    :error="$v.transfer_clients_form.group_name.$error"
                    id="group_name_transfer_clients"
                    placeholder="Group name"
                    name="group_name_transfer_clients"
                />
                <template #error>
                  <div v-if="$v.transfer_clients_form.group_name.$dirty && !$v.transfer_clients_form.group_name.required">Required field</div>
                </template>
              </app-form-group>
            </template>
            <template v-else>
              <app-form-group label="Client group" required>
                <app-select
                  @search="onClientsGroupsSearch"
                  v-model="transfer_clients_form.new_group"
                  :options="clients_groups_options"
                  :clearable="false"
                  placeholder="Client group"
                  :error="$v.transfer_clients_form.new_group.$error"
                />
                <template #error>
                  <div v-if="$v.transfer_clients_form.new_group.$dirty && !$v.transfer_clients_form.new_group.required">Required field</div>
                </template>
              </app-form-group>
            </template>
            <app-cells position="center" :indent="false">
              <app-button
                  :disabled="$v.transfer_clients_form.$error"
                  type="submit"
                  ref="transfer_clients_submit"
              >
                Complete transfer
              </app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <div class="flying-block flying-block--column flying-block--icons" :class="{ 'flying-block--show': is_show_flying_block }">
      <div class="flying-block__text">Selected clients: <span>{{ checked.length }}</span></div>
      <div class="flying-block__icons">
        <button @click="onShowAddToSafariGroupModal" type="button">
          <img src="@/assets/img/safari-flying-icon.svg" alt="">
        </button>
        <button @click="onShowAddToGroupModal('climbing')" type="button">
          <img src="@/assets/img/climbing-flying-icon.svg" alt="">
        </button>
        <button @click="onShowAddToDayTripModal" type="button">
          <img src="@/assets/img/day-trip-flying-icon.svg" alt="">
        </button>
        <button @click="onShowAddToIslandModal" type="button">
          <img src="@/assets/img/island-flying-icon.svg" alt="">
        </button>
        <button @click="onShowTransferModal" type="button">
          <img src="@/assets/img/transfer-flying-icon.svg" alt="">
        </button>
        <button @click="onShowFreeModal" type="button">
          <img src="@/assets/img/free-day-flying-icon.svg" alt="">
        </button>
        <button @click="onShowTransferClientsModal" type="button">
          <img src="@/assets/img/transfer-clients-flying-icon.svg" alt="">
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  deleteClientFromGroup,
  getClients,
  getGroundOpsInsuranceUpdates,
  getClientsFreeDays,
  getClientsGroups,
  getClientsTourOperatorManagers,
  getClimbingGroups,
  getClimbingGroupType,
  getClimbingRoutes,
  getDayTripsActivity,
  getDayTripsDayTrips,
  getGenders,
  getGoogleSearch,
  getIslandVacationGroups,
  getLanguages,
  getLeadsStatuses,
  getReservationsSafari,
  getSafariGroups,
  getSafariGroupTypes,
  postClients,
  postClientsFreeDays,
  postClientsGroupsTransferClients,
  postClientsToFreeDays,
  postClientToClimbingGroup,
  postClimbingsGroups,
  postDayTripsDayTrip,
  postDayTripsDayTripAddClient,
  postIslandVacationClientsToGroup,
  postIslandVacationGroup,
  postLocation,
  postSafariGroups,
  postSafariGroupsClients, postSafariGroupsReservation,
  postTransferOther,
} from '@/http'
import debounce from 'lodash/debounce'
import { email, helpers, required, requiredIf } from 'vuelidate/lib/validators'
import { format, parse } from 'date-fns'
import draggable from 'vuedraggable'
import { VueEditor } from 'vue2-editor'
import { channelHint, statusTone } from '@/views/ground-ops/insurance-updates/model'

const timeRegex = helpers.regex('timeRegex', /^([0-1][0-9]|2[0-3]):([0-5][0-9])?$/i)

export default {
  name: 'ClientsGroupsGeneral',
  components: { draggable, VueEditor },
  props: {
    groupData: Object,
  },
  data() {
    return {
      page_loaded: false,
      transfer_clients_form: {},
      custom_toolbar: [
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        ['clean']
      ],
      add_climbing_tour_start: null,
      create_new_group: true,
      create_new_group_free: true,
      create_new_group_island: true,
      search: null,
      insuranceUpdates: {},
      insuranceUpdatesLoading: true,
      insuranceUpdatesError: false,
      insuranceUpdateRequestId: 0,
      insuranceUpdateChannels: [{ value: 'email', icon: 'mail' }, { value: 'whatsapp', icon: 'wa' }],
      table: {
        items: [],
        columns: ['full_name', 'insurance_upd', 'transport', 'personal_data_percentage', 'climbing', 'safari', 'day_trips', 'transfers'],
        options: {
          headings: {
            select: '',
            full_name: 'Full name',
            insurance_upd: 'Insurance update',
            messengers: 'Communication',
            transport: 'Transport',
            personal_data_percentage: 'Profile',
            climbing: 'Climbing',
            safari: 'Safari',
            day_trips: 'Activities',
            transfers: 'Transfers',
            controls: '',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      languages_options: [],
      genders_options: [],
      tour_operators_options: [],
      tour_operator_managers_options: [],
      form: {
        category: 'client',
        content_language: null
      },
      activities_modal_data: [],
      activities_modal_type: '',
      activities_modal_transfer_type: '',
      medical_clearance_present: false,
      client_to_delete: {},
      checked_all: false,
      checked: [],
      is_show_flying_block: false,
      groups_options: [],
      add_clients_form: {},
      add_clients_form_safari: {},
      modal_type_add: '',
      client_hash: '',
      family_url: process.env.VUE_APP_FAMILY,
      branded_url: process.env.VUE_APP_FAMILY_PARTNER,
      group_type_options: [],
      group_type_options_climbing: [],
      routes_options: [],
      day_trip_form: {
        name: ''
      },
      day_trips_activity_options: [],
      day_trip_groups_options: [],
      location_options: [],
      location_finish_options: [],
      transfer_form: { name: '', points: [{ location: null }] },
      free_form: {
        name: '',
      },
      free_days_options: [],
      groups_search_options: [],
      island_form: {
        name: '',
      },
      island_vacation_groups: [],
      clients_groups_options: [],
      lead_status_options: [],
      type_safari_res_options: [
        { value: 'reservation', label: 'Reservation' },
        { value: 'add_to_group', label: 'Add to group' },
        { value: 'gamepackage', label: 'GamePackage' },
      ],
      type_safari_res: 'reservation',
      safari_reservations_options: [],
    }
  },
  validations: {
    form: {
      content_language: { required },
      first_name: { required },
      last_name: { required },
      email: { email },
      phone: {},
    },
    add_clients_form: {
      climbing_group: {
        required: requiredIf(function() {
          return !this.create_new_group && this.modal_type_add === 'climbing'
        })
      },
      climbing_tour_start: {
        required: requiredIf(function() {
          return this.create_new_group && this.modal_type_add === 'climbing'
        })
      },
      climbing_type: {
        required: requiredIf(function() {
          return this.create_new_group && this.modal_type_add === 'climbing'
        })
      },
      route: {
        required: requiredIf(function() {
          return this.create_new_group && this.modal_type_add === 'climbing'
        })
      },
      climbing_name: {
        required: requiredIf(function() {
          return this.create_new_group && this.modal_type_add === 'climbing'
        })
      },
    },
    add_clients_form_safari: {
      group: {
        required: requiredIf(function() {
          return this.type_safari_res === 'add_to_group'
        })
      },
      cars_required: {
        required: requiredIf(function() {
          return this.type_safari_res === 'gamepackage'
        })
      },
      name: {
        required: requiredIf(function() {
          return this.type_safari_res === 'gamepackage'
        })
      },
      type: {
        required: requiredIf(function() {
          return this.type_safari_res === 'gamepackage'
        })
      },
      tour_start: {
        required: requiredIf(function() {
          return this.type_safari_res === 'gamepackage'
        })
      },
      tour_end: {
        required: requiredIf(function() {
          return this.type_safari_res === 'gamepackage'
        })
      },
      short_itinerary: {
        required: requiredIf(function() {
          return this.type_safari_res === 'gamepackage'
        })
      },
      group_name: {
        required: requiredIf(function() {
          return this.type_safari_res === 'reservation'
        })
      },
      reservation: {
        required: requiredIf(function() {
          return this.type_safari_res === 'reservation'
        })
      },
    },
    day_trip_form: {
      name: {
        required: requiredIf(function() {
          return this.create_new_group
        })
      },
      group: {
        required: requiredIf(function() {
          return !this.create_new_group
        })
      },
      date: {
        required: requiredIf(function() {
          return this.create_new_group
        })
      },
      pick_up_location: {
        required: requiredIf(function() {
          return this.create_new_group
        })
      },
      pick_up_time: {
        required: requiredIf(function() {
          return this.create_new_group
        }),
        timeRegex
      },
      activity: {
        required: requiredIf(function() {
          return this.create_new_group
        })
      },
    },
    transfer_form: {
      points: {
        $each: {
          location: { required },
        }
      },
      pick_up_date: {
        required,
        minValue(val) {
          return val ? new Date(val) >= new Date(new Date().setHours(0, 0, 0, 0)) : true
        }
      },
      pick_up_time: {
        required,
        timeRegex
      },
      pick_up_point: { required },
      name: { required },
    },
    free_form: {
      group: {
        required: requiredIf(function() {
          return !this.create_new_group_free
        })
      },
      name: {
        required: requiredIf(function() {
          return this.create_new_group_free
        })
      },
      tour_start: {
        required: requiredIf(function() {
          return this.create_new_group_free
        })
      },
      tour_end: {
        required: requiredIf(function() {
          return this.create_new_group_free
        })
      },
      location: {
        required: requiredIf(function() {
          return this.create_new_group_free
        })
      },
    },
    island_form: {
      group: {
        required: requiredIf(function() {
          return !this.create_new_group_island
        })
      },
      name: {
        required: requiredIf(function() {
          return this.create_new_group_island
        })
      },
      tour_start: {
        required: requiredIf(function() {
          return this.create_new_group_island
        })
      },
      tour_end: {
        required: requiredIf(function() {
          return this.create_new_group_island
        })
      },
    },
    transfer_clients_form: {
      group_name: {
        required: requiredIf(function() {
          return this.create_new_group
        })
      },
      lead_name: {
        required: requiredIf(function() {
          return this.create_new_group
        })
      },
      status: {
        required: requiredIf(function() {
          return this.create_new_group
        })
      },
      new_group: {
        required: requiredIf(function() {
          return !this.create_new_group
        })
      }
    },
  },
  computed: {
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
    is_sales_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_manager')
    },
    is_sales_supervisor() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_supervisor')
    },
    is_support() {
      return this.$store.state.userGroups.map(item => item.code).includes('support')
    },
    is_operations_supervisor() {
      return this.$store.state.userGroups.map(item => item.code).includes('operations_supervisor')
    },
    dragOptions() {
      return {
        animation: 200,
        group: 'destination',
        disabled: false,
        ghostClass: 'ghost'
      }
    },
  },
  watch: {
    checked_all(value) {
      if (value) {
        this.table.items.forEach(item => {
          if (!this.checked.includes(item.id)) this.checked.push(item.id)
        })
      } else {
        this.checked = []
      }
    },
    checked(value) {
      this.is_show_flying_block = value.length > 0
      if (!this.checked.length) this.checked_all = false
    },
  },
  created() {
    this.fetchItems()
    if (this.is_general_manager || this.is_sales_manager || this.is_sales_supervisor || this.is_support) {
      this.table.columns.unshift('select')
    }
    if (this.is_general_manager || this.is_sales_manager || this.is_sales_supervisor) {
      this.table.columns.splice(this.table.columns.indexOf('insurance_upd') + 1, 0, 'messengers')
    }
    getLanguages(true).then(res => {
      this.languages_options = res.data
      this.form.content_language = this.languages_options[0].code
    })
    getGenders().then(res => { this.genders_options = res.data })
    getSafariGroupTypes().then(res => {
      this.group_type_options = res.data
    })
    getClimbingRoutes().then(res => { this.routes_options = res.data })
    getClimbingGroupType().then(res => {
      this.group_type_options_climbing = res.data
    })
    getDayTripsActivity().then(res => { this.day_trips_activity_options = res.data })
    getDayTripsDayTrips({ category: 'upcoming' }).then(res => { this.day_trip_groups_options = res.data })
    getClientsFreeDays({client_group: this.$route.params.id}).then(res => { this.free_days_options = res.data })
    getIslandVacationGroups({client_group: this.$route.params.id}).then(res => { this.island_vacation_groups = res.data })
    getLeadsStatuses({available_for_transfer: true}).then(res => { this.lead_status_options = res.data })
    getReservationsSafari({ reservation_status: 'booked_provisionally,booked', sales_status: 'book', lead: this.groupData.lead.id })
      .then(res => {
        this.safari_reservations_options = res.data
        if (this.safari_reservations_options.length) {
          this.add_clients_form_safari.reservation = this.safari_reservations_options[0]
        }
      })
  },
  beforeDestroy() { this.insuranceUpdateRequestId += 1 },
  methods: {
    onChangeTypeSafariRes() {
      if (this.type_safari_res === 'create') {
        this.add_clients_form_safari.name = this.groupData.name
      } else if (this.type_safari_res === 'reservation') {
        this.add_clients_form_safari.name = this.groupData.lead.name
      }
    },
    onCheckTransferClientsForm() {
      this.$v.transfer_clients_form.$touch()
      if (this.$v.transfer_clients_form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendTransferClientsForm()
      }
    },
    sendTransferClientsForm() {
      this.$refs.transfer_clients_submit.preload = true
      postClientsGroupsTransferClients(this.normalizeTransferClientsForm())
        .then(() => {
          this.fetchItems()
          this.$modal.hide('transfer-clients-form')
          this.$notify({
            type: 'success',
            title: 'Transfer completed',
          })
          this.transfer_clients_form = {}
          this.checked = []
          this.$v.transfer_clients_form.$reset()
          this.$emit('update-group')
        })
        .catch(() => { this.$refs.transfer_clients_submit.preload = false })
    },
    normalizeTransferClientsForm() {
      const form = { ...this.transfer_clients_form }

      form.source_group = +this.$route.params.id
      form.clients = this.checked
      if (!this.create_new_group) {
        form.new_group = form.new_group.id
        delete form.group_name
        delete form.lead_name
        delete form.status
      }
      return form
    },
    onClientsGroupsSearch(search, loading) {
      loading(true)
      this.searchClientsGroups(loading, search, this)
    },
    searchClientsGroups: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.clients_groups_options = []
      } else {
        getClientsGroups({search}).then(response => {
          vm.clients_groups_options = response.data
          loading(false)
        })
      }
    }, 350),
    onShowTransferClientsModal() {
      this.$modal.show('transfer-clients-form')
    },
    onSetFreeStart() {
      this.$refs.free_tour_end.$children[0].focus()
    },
    onSetIslandStart() {
      this.$refs.island_tour_end.$children[0].focus()
    },
    onTransferPickUpPointSelected({ name, place_id }) {
      this.$refs.transfer_submit.preload = true
      postLocation({ name, place_id }).then(res => {
        this.transfer_form.pick_up_point = res.data
        this.$refs.transfer_submit.preload = false
      })
    },
    onRemoveTransferDestination(type, index) {
      this.transfer_form.points.splice(index, 1)
      this.$v.transfer_form.points.$touch()
    },
    onAddTransferDestination() {
      this.transfer_form.points.push({ location: null })
    },
    onTransferLocationSelected({ name, place_id }, index) {
      this.$refs.transfer_submit.preload = true
      postLocation({ name, place_id }).then(res => {
        this.transfer_form.points[index].location = res.data
        this.$refs.transfer_submit.preload = false
      })
    },
    onShowFreeModal() {
      this.free_form.name = this.groupData.name
      this.$modal.show('free-day-modal')
    },
    onCheckFreeForm() {
      this.$v.free_form.$touch()
      if (this.$v.free_form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendFreeForm()
      }
    },
    sendFreeForm() {
      this.$refs.free_submit.preload = true
      if (this.create_new_group_free) {
        const data = {
          clients: this.checked,
          tour_start: this.free_form.tour_start,
          tour_end: this.free_form.tour_end,
          name: this.free_form.name,
          location: this.free_form.location.id
        }
        if (this.free_form.notes) data.notes = this.free_form.notes
        postClientsFreeDays(data)
          .then(() => {
            this.fetchItems()
            this.$emit('update-group')
            this.$notify({
              type: 'success',
              title: 'Group created',
            })
            this.$modal.hide('free-day-modal')
            this.$v.free_form.$reset()
            this.checked = []
          })
          .catch(() => { this.$refs.free_submit.preload = false })
      } else {
        postClientsToFreeDays(this.free_form.group.id, {clients: this.checked})
          .then(() => {
            this.fetchItems()
            this.$emit('update-group')
            this.$notify({
              type: 'success',
              title: 'Clients added',
            })
            this.$modal.hide('free-day-modal')
            this.$v.free_form.$reset()
            this.checked = []
          })
          .catch(() => { this.$refs.free_submit.preload = false })
      }
    },
    onShowAddToIslandModal() {
      this.island_form.name = this.groupData.name
      this.$modal.show('island-modal')
    },
    onCheckIslandForm() {
      this.$v.island_form.$touch()
      if (this.$v.island_form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendIslandForm()
      }
    },
    sendIslandForm() {
      this.$refs.island_submit.preload = true
      if (this.create_new_group_island) {
        const data = {
          clients: this.checked,
          tour_start: this.island_form.tour_start,
          tour_end: this.island_form.tour_end,
          name: this.island_form.name,
        }
        if (this.island_form.itinerary_description) data.itinerary_description = this.island_form.itinerary_description
        postIslandVacationGroup(data)
          .then(() => {
            this.fetchItems()
            this.$emit('update-group')
            this.$notify({
              type: 'success',
              title: 'Group created',
            })
            this.$modal.hide('island-modal')
            this.$v.island_form.$reset()
            this.checked = []
          })
          .catch(() => { this.$refs.island_submit.preload = false })
      } else {
        postIslandVacationClientsToGroup(this.island_form.group.id, {clients: this.checked})
          .then(() => {
            this.fetchItems()
            this.$emit('update-group')
            this.$notify({
              type: 'success',
              title: 'Clients added',
            })
            this.$modal.hide('island-modal')
            this.$v.island_form.$reset()
            this.checked = []
          })
          .catch(() => { this.$refs.island_submit.preload = false })
      }
    },
    onCheckTransferForm() {
      this.$v.transfer_form.$touch()
      if (this.$v.transfer_form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendTransferForm()
      }
    },
    sendTransferForm() {
      this.$refs.transfer_submit.preload = true
      postTransferOther(this.normalizeTransferForm())
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Transfer saved',
          })
          this.$modal.hide('transfer-modal')
          this.checked = []
          this.fetchItems()
          this.$emit('update-group')
        })
        .catch(() => { this.$refs.transfer_submit.preload = false })
    },
    normalizeTransferForm() {
      let points = [ ...this.transfer_form.points ]

      points = points.map((item, index) => ({ location: item.location.id, sort: index, id: item.id }))
      return {
        points,
        clients: this.checked,
        pick_up_date: this.transfer_form.pick_up_date,
        pick_up_time: this.transfer_form.pick_up_time,
        pick_up_point: this.transfer_form.pick_up_point.id,
        notes: this.transfer_form.notes,
        name: this.transfer_form.name,
      }
    },
    onShowTransferModal() {
      this.transfer_form.name = this.groupData.name
      this.$modal.show('transfer-modal')
    },
    onLocationSelected({ name, place_id }) {
      this.$refs.day_trip_submit.preload = true
      postLocation({ name, place_id }).then(res => {
        this.day_trip_form.pick_up_location = res.data
        this.$refs.day_trip_submit.preload = false
      })
    },
    onFreeLocationSelected({ name, place_id }) {
      postLocation({ name, place_id }).then(res => {
        this.free_form.location = res.data
      })
    },
    onLocationStartSelected({ name, place_id }) {
      postLocation({ name, place_id }).then(res => {
        this.add_clients_form_safari.start_from = res.data
      })
    },
    onLocationFinishSelected({ name, place_id }) {
      postLocation({ name, place_id }).then(res => {
        this.add_clients_form_safari.finish_at = res.data
      })
    },
    onSelectClimbingStart(date) {
      this.add_clients_form.climbing_group = ''
      if (date) {
        getClimbingGroups({tour_start: this.add_climbing_tour_start, category: 'upcoming'}).then(response => {
          this.groups_options = response.data
        })
      }
    },
    onSetTourStart() {
      this.$refs.tour_end.$children[0].focus()
    },
    tooltipSafariContent(data) {
      return `${data.name}<br>${this.dateFormat(data.tour_start)} - ${this.dateFormat(data.tour_end)}`
    },
    tooltipTransportContent(data, transport_type) {
      if (!data[`${transport_type}_method`]) return
      return `${this.dateFormat(data[`${transport_type}_date`])} ${data[`${transport_type}_time`]}<br>${data[`${transport_type}_location`] ? data[`${transport_type}_location`].short_name : ''}<br>${data[`${transport_type}_flight_number`] || ''}`
    },
    tooltipClimbingContent(data) {
      return `${data.name}<br>${data.route.name} ${data.route.duration}<br>${this.dateFormat(data.tour_start)} - ${this.dateFormat(data.tour_end)}`
    },
    tooltipInsuranceContent(data, type) {
      if (!data[`${type}_insurance_company`]) return
      return `${data[`${type}_insurance_company`]}<br>${data[`${type}_insurance_number`]}<br>${this.dateFormat(data[`${type}_insurance_coverage_start`])} - ${this.dateFormat(data[`${type}_insurance_coverage_end`])}<br>${data[`${type}_insurance_emergency_phone`]}`
    },
    tooltipDayTripsContent(data) {
      return `${data.ready_to_join ? '[J] ' : ''}${data.name}<br>${this.dateFormat(data.date)} ${data.pick_up_time}<br>${data.activity.short_name}`
    },
    tooltipFreeDaysContent(data) {
      return `${this.dateFormat(data.tour_start)} - ${this.dateFormat(data.tour_end)}<br>${data.location.short_name}`
    },
    tooltipIslandContent(data) {
      return `${data.name}<br>${this.dateFormat(data.tour_start)} - ${this.dateFormat(data.tour_end)}`
    },
    tooltipChecklistContent(data) {
      if (!data.completed || data.total_price <= 0) return
      return `Rental items: ${data.rental_items}<br>Purchase items: ${data.purchase_items}<br>Total price: ${data.total_price}`
    },
    tooltipSnackBarContent(data) {
      if (!data.snack_bar) return
      if (!data.snack_bar.completed) return 'Not completed'
      if (data.snack_bar.no_need) return 'No need'
      if (data.snack_bar.completed && data.snack_bar.outstanding_amount > 0) return `Completed. Unpaid.<br>Items: ${data.snack_bar.items_count}<br>Order amount: ${data.snack_bar.order_amount.toLocaleString()}$<br>Credit: ${data.snack_bar.credit.toLocaleString()}$<br>Outstanding amount: ${data.snack_bar.outstanding_amount.toLocaleString()}$`
      if (data.snack_bar.completed && data.snack_bar.outstanding_amount === 0) return `Completed.<br>Items: ${data.snack_bar.items_count}<br>Order amount: ${data.snack_bar.order_amount.toLocaleString()}$<br>Credit: ${data.snack_bar.credit.toLocaleString()}$`
    },
    onCopyTransportData(data, transport_type) {
      let string = `${this.dateFormat(data[`${transport_type}_date`])} ${data[`${transport_type}_time`]}\n${data[`${transport_type}_location`] ? data[`${transport_type}_location`].short_name : ''}`
      if (data[`${transport_type}_flight_number`]) string += `\n${data[`${transport_type}_flight_number`]}`
      this.copyToClipboard(string)
    },
    onCopyInsuranceData(data, type) {
      const string = `${data[`${type}_insurance_company`]}\n${data[`${type}_insurance_number`]}\n${this.dateFormat(data[`${type}_insurance_coverage_start`])} - ${this.dateFormat(data[`${type}_insurance_coverage_end`])}\n${data[`${type}_insurance_emergency_phone`]}`
      this.copyToClipboard(string)
    },
    copyToClipboard(string) {
      navigator.clipboard.writeText(string)
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Copied to clipboard',
          })
        })
        .catch(() => { console.error('Something went wrong') })
    },
    onChangeRUToUS(value, prop) {
      let answer = ''
      const converter = {
        'а': 'a',
        'б': 'b',
        'в': 'v',
        'г': 'g',
        'д': 'd',
        'е': 'e',
        'ё': 'e',
        'ж': 'zh',
        'з': 'z',
        'и': 'i',
        'й': 'y',
        'к': 'k',
        'л': 'l',
        'м': 'm',
        'н': 'n',
        'о': 'o',
        'п': 'p',
        'р': 'r',
        'с': 's',
        'т': 't',
        'у': 'u',
        'ф': 'f',
        'х': 'h',
        'ц': 'c',
        'ч': 'ch',
        'ш': 'sh',
        'щ': 'sch',
        'ь': '',
        'ы': 'y',
        'ъ': '',
        'э': 'e',
        'ю': 'yu',
        'я': 'ya',
        'А': 'A',
        'Б': 'B',
        'В': 'V',
        'Г': 'G',
        'Д': 'D',
        'Е': 'E',
        'Ё': 'E',
        'Ж': 'Zh',
        'З': 'Z',
        'И': 'I',
        'Й': 'Y',
        'К': 'K',
        'Л': 'L',
        'М': 'M',
        'Н': 'N',
        'О': 'O',
        'П': 'P',
        'Р': 'R',
        'С': 'S',
        'Т': 'T',
        'У': 'U',
        'Ф': 'F',
        'Х': 'H',
        'Ц': 'C',
        'Ч': 'Ch',
        'Ш': 'Sh',
        'Щ': 'Sch',
        'Ь': '',
        'Ы': 'Y',
        'Ъ': '',
        'Э': 'E',
        'Ю': 'Yu',
        'Я': 'Ya'
      }

      for (let i = 0; i < value.length; ++i) {
        if (converter[value[i]] === undefined) {
          answer += value[i]
        } else {
          answer += converter[value[i]]
        }
      }
      this.form[prop] = answer
    },
    onShowCreateModal() {
      this.$modal.show('client-form')
    },
    onShowDeleteModal(client_data) {
      this.client_to_delete = client_data
      this.$modal.show('delete-modal')
    },
    onDeleteClient() {
      this.$refs.delete_button.preload = true
      deleteClientFromGroup(this.$route.params.id, this.client_to_delete.id)
        .then(() => {
          this.fetchItems()
          this.$emit('update-group')
          this.$notify({
            type: 'success',
            title: 'Client deleted',
          })
          this.$modal.hide('delete-modal')
        })
        .catch(() => { this.$refs.delete_button.preload = false })
    },
    fetchItems() {
      this.page_loaded = false
      getClients({ group: this.$route.params.id, ordering: 'created_at' })
        .then(res => { this.table.items = res.data })
        .finally(() => { this.page_loaded = true })
      this.loadInsuranceUpdates()
    },
    async loadInsuranceUpdates() {
      const byClient = {}
      const groupId = this.$route.params.id
      const requestId = ++this.insuranceUpdateRequestId
      this.insuranceUpdatesLoading = true
      this.insuranceUpdatesError = false
      let page = 1
      try {
        while (true) {
          const response = await getGroundOpsInsuranceUpdates({ group_id: groupId, page, page_size: 100 })
          if (requestId !== this.insuranceUpdateRequestId || this.$route.params.id !== groupId) return
          response.data.results.forEach(item => {
            if (!byClient[item.client]) byClient[item.client] = {}
            byClient[item.client][item.channel] = item
          })
          if (!response.data.next) break
          page += 1
        }
        this.insuranceUpdates = byClient
      } catch (error) {
        if (requestId === this.insuranceUpdateRequestId && this.$route.params.id === groupId) {
          this.insuranceUpdates = {}
          this.insuranceUpdatesError = true
        }
      } finally {
        if (requestId === this.insuranceUpdateRequestId && this.$route.params.id === groupId) this.insuranceUpdatesLoading = false
      }
    },
    insuranceUpdateTone(clientId, channel) {
      if (this.insuranceUpdatesLoading) return 'neutral'
      if (this.insuranceUpdatesError) return 'amber'
      const delivery = (this.insuranceUpdates[clientId] || {})[channel]
      return statusTone(delivery ? delivery.status : 'not_prepared')
    },
    insuranceUpdateTooltip(clientId, channel) {
      const label = channel === 'email' ? 'Email' : 'WhatsApp'
      if (this.insuranceUpdatesLoading) return `${label}: Loading insurance status…`
      if (this.insuranceUpdatesError) return `${label}: Could not load insurance status`
      const delivery = (this.insuranceUpdates[clientId] || {})[channel]
      return channelHint(channel, delivery ? delivery.status : 'not_prepared', delivery ? delivery.reason : '')
    },
    onShowActivitiesModal(data, modalType, transferType = null) {
      if (transferType) this.activities_modal_data = data[modalType][transferType]
      else this.activities_modal_data = data[modalType]
      this.client_hash = data.hash
      this.activities_modal_type = modalType
      this.activities_modal_transfer_type = transferType
      this.medical_clearance_present = !!data.medical_clearance
      this.$modal.show('activities-modal')
    },
    onHideModalActivities() {
      this.$modal.hide('activities-modal')
      this.medical_clearance_present = false
    },
    dateFormat(date) {
      return format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy')
    },
    onCopyFamilyLink(hash) {
      const string = `${this.groupData.lead?.tour_operator?.branding ? this.branded_url : this.family_url}${hash}`
      navigator.clipboard.writeText(string)
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Link copied to clipboard',
          })
        })
        .catch(() => { console.error('Something went wrong') })
    },
    onCopyFamilyLinks() {
      let string = ''
      this.table.items.forEach((item, index, array) => {
        if (this.groupData.lead?.tour_operator?.branding) {
          string += `${item.full_name}: ${this.branded_url}${item.hash}${index === array.length - 1 ? '' : '\n'}`
        } else string += `${item.full_name}: ${this.family_url}${item.hash}${index === array.length - 1 ? '' : '\n'}`
      })
      navigator.clipboard.writeText(string)
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Links copied to clipboard',
          })
        })
        .catch(() => { console.error('Something went wrong') })
    },
    onCopyContactLink(link) {
      navigator.clipboard.writeText(link)
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Copied to clipboard',
          })
        })
        .catch(() => { console.error('Something went wrong') })
    },
    tooltipPassportContent(data) {
      if (!data.citizenship || !data.passport || !data.dob) return false
      return `${data.citizenship.code}, ${data.passport}, ${this.dateFormat(data.dob)}`
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
    onClimbingGroupSearch(search, loading) {
      loading(true)
      this.searchClimbingGroup(loading, search, this)
    },
    searchClimbingGroup: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.groups_search_options = []
      } else {
        getClimbingGroups({search, category: 'upcoming'}).then(response => {
          vm.groups_search_options = response.data
          loading(false)
        })
      }
    }, 350),
    onTourOperatorChange() {
      if (this.form.tour_operator) {
        getClientsTourOperatorManagers({ tour_operator: this.form.tour_operator })
          .then(res => { this.tour_operator_managers_options = res.data.results })
      } else {
        this.form.tour_operator_manager = null
        this.tour_operator_managers_options = []
      }
    },
    onCheckForm () {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submit.preload = true
      postClients({ ...this.form, group: this.$route.params.id })
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Client created',
          })
          this.fetchItems()
          this.$emit('update-group')
          this.$modal.hide('client-form')
          this.form = {
            category: 'client',
          }
          this.form.content_language = this.languages_options[0].code
          this.$v.form.$reset()
        })
        .catch(() => { this.$refs.submit.preload = false })
    },
    onShowAddToGroupModal(modalType) {
      this.modal_type_add = modalType
      this.add_clients_form = {
        climbing_type: '',
        climbing_group: '',
      }
      if (this.group_type_options_climbing.length) this.add_clients_form.climbing_type = this.group_type_options_climbing[0].code
      this.groups_options = []
      this.$v.add_clients_form.$reset()
      this.add_clients_form.climbing_name = this.groupData.name
      this.$modal.show('add-group-form')
    },
    onShowAddToSafariGroupModal() {
      this.add_clients_form_safari = {
        type: '',
      }
      if (this.group_type_options.length) this.add_clients_form_safari.type = this.group_type_options[0].code
      this.groups_options = []
      this.add_clients_form_safari.name = this.groupData.name
      this.$v.add_clients_form_safari.$reset()
      this.$modal.show('add-group-safari-form')
    },
    checkAddClientsSafariForm() {
      this.$v.add_clients_form_safari.$touch()
      if (this.$v.add_clients_form_safari.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendAddClientsSafariForm()
      }
    },
    sendAddClientsSafariForm() {
      this.$refs.clientAddSafariSubmit.preload = true
      if (this.type_safari_res === 'gamepackage') {
        const data = {
          cars_required: this.add_clients_form_safari.cars_required,
          name: this.add_clients_form_safari.name,
          tour_start: this.add_clients_form_safari.tour_start,
          tour_end: this.add_clients_form_safari.tour_end,
          short_itinerary: this.add_clients_form_safari.short_itinerary,
          clients: this.checked,
          type: this.type_safari_res
        }
        if (this.add_clients_form_safari.start_from) data.start_from = this.add_clients_form_safari.start_from.id
        if (this.add_clients_form_safari.finish_at) data.finish_at = this.add_clients_form_safari.finish_at.id
        postSafariGroups(data)
          .then(() => {
            this.fetchItems()
            this.$emit('update-group')
            this.$notify({
              type: 'success',
              title: 'Clients added',
            })
            this.$modal.hide('add-group-safari-form')
            this.checked = []
          })
          .catch(() => { this.$refs.clientAddSafariSubmit.preload = false })
      } else if (this.type_safari_res === 'reservation') {
        postSafariGroupsReservation({
          name: this.add_clients_form_safari.group_name,
          reservation: this.add_clients_form_safari.reservation,
          clients: this.checked,
          type: this.type_safari_res
        })
          .then(() => {
            this.fetchItems()
            this.$emit('update-group')
            this.$notify({
              type: 'success',
              title: 'Clients added',
            })
            this.$modal.hide('add-group-safari-form')
            this.checked = []
          })
          .catch(() => { this.$refs.clientAddSafariSubmit.preload = false })
      } else if (this.type_safari_res === 'add_to_group') {
        postSafariGroupsClients(this.add_clients_form_safari.group.id, { clients: this.checked, type: this.type_safari_res })
          .then(() => {
            this.$notify({
              type: 'success',
              title: 'Clients added',
            })
            this.fetchItems()
            this.$emit('update-group')
            this.$modal.hide('add-group-safari-form')
            this.checked = []
          })
          .catch(() => { this.$refs.clientAddSafariSubmit.preload = false })
      }
    },
    onShowAddToDayTripModal() {
      this.day_trip_form.name = this.groupData.name
      this.$modal.show('day-trip-modal')
    },
    onCheckDayTripForm() {
      this.$v.day_trip_form.$touch()
      if (this.$v.day_trip_form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendAddDayTripForm()
      }
    },
    sendAddDayTripForm() {
      this.$refs.day_trip_submit.preload = true
      if (this.create_new_group) {
        this.day_trip_form.clients = this.checked
        postDayTripsDayTrip({...this.day_trip_form, pick_up_location: this.day_trip_form.pick_up_location.id})
          .then(() => {
            this.fetchItems()
            this.$emit('update-group')
            this.$notify({
              type: 'success',
              title: 'Day trip created',
            })
            this.$modal.hide('day-trip-modal')
            this.checked = []
          })
          .catch(() => { this.$refs.day_trip_submit.preload = false })
      } else {
        postDayTripsDayTripAddClient(this.day_trip_form.group, { clients: this.checked })
          .then(() => {
            this.fetchItems()
            this.$emit('update-group')
            this.$notify({
              type: 'success',
              title: 'Clients adding successful',
            })
            this.$modal.hide('day-trip-modal')
            this.checked = []
          })
      }
    },
    checkAddClientsForm() {
      this.$v.add_clients_form.$touch()
      if (this.$v.add_clients_form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendAddClientsForm()
      }
    },
    sendAddClientsForm() {
      this.$refs.clientAddSubmit.preload = true
      if (this.create_new_group) {
        const data = {
          name: this.add_clients_form.climbing_name,
          type: this.add_clients_form.climbing_type,
          tour_start: this.add_clients_form.climbing_tour_start,
          route: this.add_clients_form.route,
          clients: this.checked
        }
        postClimbingsGroups(data)
          .then(() => {
            this.fetchItems()
            this.$emit('update-group')
            this.$notify({
              type: 'success',
              title: 'Clients added',
            })
            this.$modal.hide('add-group-form')
            this.checked = []
          })
          .catch(() => { this.$refs.clientAddSubmit.preload = false })
      } else {
        postClientToClimbingGroup(this.add_clients_form.climbing_group.id, { clients: this.checked })
          .then(() => {
            this.$notify({
              type: 'success',
              title: 'Clients added',
            })
            this.fetchItems()
            this.$emit('update-group')
            this.$modal.hide('add-group-form')
            this.checked = []
            this.add_climbing_tour_start = null
          })
          .catch(() => { this.$refs.clientAddSubmit.preload = false })
      }
    },
    onGroupSafariSearch(search, loading) {
      loading(true)
      this.searchSafariGroup(loading, search, this)
    },
    searchSafariGroup: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.groups_options = []
      } else {
        getSafariGroups({search, category: 'upcoming'}).then(response => {
          vm.groups_options = response.data
          loading(false)
        })
      }
    }, 350),
    onLocationSearch(search, loading) {
      loading(true)
      this.searchLocation(loading, search, this)
    },
    searchLocation: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.location_options = []
      } else {
        getGoogleSearch(search).then(response => {
          vm.location_options = response.data
          loading(false)
        })
      }
    }, 350),
    onLocationFinishSearch(search, loading) {
      loading(true)
      this.searchFinishLocation(loading, search, this)
    },
    searchFinishLocation: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.location_finish_options = []
      } else {
        getGoogleSearch(search).then(response => {
          vm.location_finish_options = response.data
          loading(false)
        })
      }
    }, 350),
  }
}
</script>

<style scoped lang="scss">
.insurance-update-heading { white-space: nowrap; }
.insurance-update-status { display: inline-block; pointer-events: auto; cursor: help; }
.insurance-update-status--green { background-color: $ui-green; }
.insurance-update-status--blue { background-color: $ui-blue; }
.insurance-update-status--amber { background-color: $ui-amber; }
.insurance-update-status--red { background-color: $ui-red; }
.insurance-update-status:focus-visible { outline: 2px solid $ui-blue; outline-offset: 3px; }
</style>
